import React, { useContext } from "react";
import SelectBox from "components/FormElements/SelectBox";
import Label from "components/FormElements/Label";
import { useSelector } from "react-redux";
import { ContainerContext } from "context/Container";

export default function LayoutTemplateField(props) {
    const { state } = useContext(ContainerContext);

    const contentFlow = useSelector((state) => state.contentFlow);

    if (state.loading) {
        return (
            <div>
                <Label>Layout</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    const vals = contentFlow.layouts.container.map((layout) => {
        return {
            value: layout,
            label: layout,
        };
    });
    vals.unshift({ value: "Default", label: "Default" });

    return (
        <SelectBox
            label="Layout"
            name="layout_template"
            id="layout_template"
            disabled={
                state.loading ||
                state.preformingStateChange ||
                !state.isUserEditable
            }
            options={vals}
        />
    );
}
